export default __webpack_public_path__ + "static/media/git.25ad932d.gif";